import { Member } from '../../../../../../../api/groups';
import useTableData, { ScorableItemRowHeader as TScorableItemRowHeader } from '../../hooks/useTableData';
import ScorableItemResultCell from './components/ScorableItemResultCell';
import ScorableItemRowHeader, { ScorableItemRowHeaderProps } from './components/ScorableItemRowHeader';

type Level = ScorableItemRowHeaderProps['level'];

interface Props {
  scorableItem: TScorableItemRowHeader;
  level: Level;
  members: Member[];
  getResult: ReturnType<typeof useTableData>['getResultForScorableMaterial'];
}

export default function MultiMemberScorableItemRow({ scorableItem, level, members, getResult }: Props) {
  return (
    <tr data-testid={`scorable-item-${scorableItem.materialId}-${scorableItem.scorableItemType}`}>
      <ScorableItemRowHeader scorableItem={scorableItem} level={level} />
      {members.map(member => (
        <ScorableItemResultCell
          key={`result-${member.id}-${scorableItem.materialId}`}
          memberId={member.id}
          materialId={scorableItem.materialId}
          type={scorableItem.scorableItemType}
          quantifiable={!scorableItem.unachievable}
          getResult={getResult}
        />
      ))}
    </tr>
  );
}
